import React, { useState } from 'react'
import { Add, Remove } from '@mui/icons-material'
import { Box, FormControl, TextField, Button } from '@mui/material'

type LineItems = {
  lineItemValue: string[]
}

export const MultiTextItemFieldArray = (props: any) => {
  const { onChange, lineItemFields = ['main'] } = props
  const [lineItems, setLineItems] = useState<LineItems[]>([
    { lineItemValue: [] },
  ])
  const [errorFields, setErrorFields] = useState<boolean[]>([false])

  const onAddLineItem = () => {
    const newLineItems = [...lineItems, { lineItemValue: [] }]
    setLineItems(newLineItems)
    setErrorFields([...errorFields, false])
    onChange(newLineItems)
  }

  const onRemoveLineItem = (index: number) => {
    const newLineItems = [...lineItems]
    newLineItems.splice(index, 1)
    setLineItems(newLineItems)
    const newErrorFields = [...errorFields]
    newErrorFields.splice(index, 1)
    setErrorFields(newErrorFields)
    onChange(newLineItems)
  }

  const onLineItemChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
    lKey: number
  ) => {
    const newLineItems = [...lineItems]
    newLineItems[index].lineItemValue[lKey] = event.target.value
    setLineItems(newLineItems)
    if (lineItemFields[lKey] === 'email') {
      const isValidEmail = validateEmail(event.target.value)
      const newErrorFields = [...errorFields]
      newErrorFields[index] = !isValidEmail && event.target.value !== ''
      setErrorFields(newErrorFields)
    }
    onChange(newLineItems)
  }

  const validateEmail = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  return (
    <Box
      sx={{ flex: 1, alignItems: 'center', alignContent: 'flex-start', mt: 2 }}>
      {lineItems.map((lineItem, key: number) => (
        <div key={key}>
          {lineItemFields.map((lIF: any, lKey: number) => (
            <FormControl sx={{ mr: 1, mt: 1, width: 200 }} key={lKey}>
              <TextField
                label={lIF}
                name={lIF}
                variant='filled'
                value={lineItem.lineItemValue[lKey] || ''}
                onChange={e => onLineItemChange(e, key, lKey)}
                error={errorFields[key] && lIF === 'email'}
                helperText={
                  errorFields[key] && lIF === 'email'
                    ? 'Invalid email format'
                    : undefined
                }
              />
            </FormControl>
          ))}
          <Button
            variant='contained'
            color='secondary'
            sx={{ m: 1, padding: '16px 26px' }}
            onClick={onAddLineItem}
            startIcon={<Add />}>
            Add
          </Button>
          {lineItems.length > 1 && (
            <Button
              variant='contained'
              color='secondary'
              sx={{ m: 1, padding: '16px 26px' }}
              onClick={() => onRemoveLineItem(key)}
              startIcon={<Remove />}></Button>
          )}
        </div>
      ))}
    </Box>
  )
}
